function vote() {
	const url = this.closest('[data-path]').dataset.path
	const parent = this.closest('[data-id]')
	const id = parent.dataset.id
	const action = this.dataset.action
	const badges = parent.querySelector('.item-photo-battle__badges-count')
	fetch(url, {
		method: 'POST',
		body: JSON.stringify({ id: id, action: action }),
	})
	.then(res => res.json())
	.then(data => {
			const voteSum =  document.querySelectorAll('.tooltiptext strong')
			const btns = document.querySelectorAll('[data-action="vote"]')
			const handler = () => {
				badges.textContent = data.count
				if (action == 'vote') {
					parent
						.querySelector('[data-action="unvote"]')
						.removeAttribute('style')
				} else {
					parent.querySelector('[data-action="vote"]').removeAttribute('style')
					btns.forEach(el => el.closest('div').classList.remove('tooltip'))
				}
				voteSum.forEach(el => el.textContent = data.voteSum)
				this.style = 'display:none'
			}
			
			if (data.status === 'success') {
				handler()
			} else if (data.status === 'reject') {
				btns.forEach(el => el.classList.add('tooltip'))
				handler()
			}
		})
}
